import React, { useEffect } from 'react';
import is from 'is_js';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';
import { useAppContext } from 'providers/AppProvider';
import { AuthProvider } from 'contexts/AuthContext';
import { CompanyConfigProvider } from 'contexts/CompanyConfigContext';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useAppContext();

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [HTMLClassList, navbarPosition]);

  return (
    <CompanyConfigProvider>
      <AuthProvider>
        <Outlet />
        <ToastContainer
          closeButton={CloseButton}
          icon={false}
          position="bottom-left"
        />
      </AuthProvider>
    </CompanyConfigProvider>
  );
};

export default App;
